module.exports = __webpack_public_path__ + "assets/play-button.735fe9c2.svg";